import React, { useEffect, useState } from "react";
import { Modal, Input } from "antd";
import { useTranslation } from "react-i18next";

interface Props {
  open: boolean;
  onClose: () => void;
  defaultName?: string;
  saving?: boolean;
  onConvert: (name: string, description: string) => void;
}

const ConvertToTemplateModal: React.FC<Props> = ({
  open,
  onClose,
  defaultName = "Untitled report",
  saving = false,
  onConvert,
}) => {
  const { t } = useTranslation("reporting");
  const [name, setName] = useState(defaultName);
  const [description, setDescription] = useState("");

  useEffect(() => {
    if (open) {
      setName(defaultName);
      setDescription("");
    }
  }, [open, defaultName]);

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={440}
      title={<div className="rb-convert__title">{t("common.convertToTemplate")}</div>}
      className="rb-convert-modal"
    >
      <div className="rb-convert__field">
        <label>{t("convertToTemplateModal.nameLabel")}</label>
        <Input
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder={t("common.untitledReport")}
        />
      </div>
      <div className="rb-convert__field">
        <label>
          {t("convertToTemplateModal.descriptionLabel")} <span className="rb-convert__optional">({t("convertToTemplateModal.optional")})</span>
        </label>
        <Input.TextArea
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder={t("convertToTemplateModal.descriptionPlaceholder")}
          rows={3}
        />
      </div>
      <div className="rb-convert__actions">
        <button className="rb-btn rb-btn--ghost" onClick={onClose} disabled={saving}>
          {t("convertToTemplateModal.cancel")}
        </button>
        <button
          className="rb-btn rb-btn--primary"
          disabled={!name.trim() || saving}
          onClick={() => onConvert(name.trim(), description.trim())}
        >
          {saving ? t("convertToTemplateModal.converting") : t("convertToTemplateModal.convert")}
        </button>
      </div>
    </Modal>
  );
};

export default ConvertToTemplateModal;
